//-- Copyright (c) 2021 TMT Insights Group, LLC
import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Button, Modal } from '@mui/material';
import NotificationPopoutContent from './NotificationPopoutContent';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { getNotifications } from '@/redux/slices/notificationSlice';
import { selectNotificationGroupTypes } from '@/redux/selectors/notificationSelectors';

interface NotificationsPopoutModalProps {
  showNotificationsModal: boolean;
  onClose: () => void;
  onShowNotificationSettings: () => void;
}

const NotificationsPopoutModal = ({ onClose, onShowNotificationSettings, showNotificationsModal }: NotificationsPopoutModalProps) => {
  const dispatch = useAppDispatch();
  const groupTypes = useAppSelector(selectNotificationGroupTypes);

  useEffect(() => {
    if (showNotificationsModal && groupTypes.length) {
      groupTypes.forEach((groupType, index) => {
        dispatch(getNotifications({ page: 0, group_type: groupType, skipStatsFetch: index !== 0 }));
      });
    }
  }, [showNotificationsModal, groupTypes]);

  return (
    <StyledModal open={showNotificationsModal}>
      <Content>
        <NotificationPopoutContent showAll onShowNotificationSettings={onShowNotificationSettings} onCloseClicked={onClose} />
        {/* TODO KYLE: this doesnt actaully do anything so im hiding it for now 
        <ArchiveContainer>
          <AcrhiveButton color="default" startIcon={<PolarisIcon icon="archive" />}>
            Archive All
          </AcrhiveButton>
        </ArchiveContainer> */}
      </Content>
    </StyledModal>
  );
};

export default NotificationsPopoutModal;

const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;

  .notification-popout-content {
    width: 592px;
    background-color: ${({ theme }) => theme.palette.background.paper};
  }
`;

const Content = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.shape.borderRadius / 2}px;
`;

// const ArchiveContainer = styled.div`
//   display: flex;
//   padding: ${({ theme }) => theme.spacing(1, 0)};
// `;

// const AcrhiveButton = styled(Button)`
//   font-size: 0.785rem;
//   font-style: normal;
//   font-weight: 500;
//   line-height: normal;
//   margin-left: auto;
//   margin-right: ${(props) => props.theme.spacing(1)};
// `;
